/**
 * Get index article page contents from props.
 *
 * @return {boolean|*}
 * @param associatedContent
 */
export function getIndexArticlePageList(associatedContent) {
  const content = Array.isArray(associatedContent) ? associatedContent.find(({ type }) => type === 'indexArticlePageList') : false;
  if (!content) {
    return false;
  }

  return content;
}
